import styled from '@emotion/styled';
import { ob } from '../onboardingV2.tokens';

export const Search = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 48px;
    padding: 0 14px;
    margin-bottom: 14px;
    border-radius: ${ob.radius.md};
    border: 1px solid ${ob.color.border};
    background: ${ob.color.surface};

    &:focus-within {
        border-color: ${ob.color.lime};
        box-shadow: 0 0 0 3px ${ob.color.lime200};
    }

    > i {
        color: ${ob.color.muted};
        font-size: 18px;
    }

    input {
        flex: 1;
        min-width: 0;
        border: 0;
        outline: none;
        background: transparent;
        font-size: 16px;
        color: ${ob.color.text};

        &::placeholder {
            color: ${ob.color.muted};
        }
    }
`;

export const NoResults = styled.p`
    margin: 8px 0 0;
    font-size: 14px;
    color: ${ob.color.muted};
    text-align: center;
`;

/** "Usar «Autos» como mi nicho" card, after the matching niches. */
export const CustomNiche = styled.div`
    margin: 12px 0 0;
`;
